import { useEffect, useRef, useState } from "react";

const useFocusWithin = <T extends HTMLElement>() => {
    const ref = useRef<T>(null);
    const [isFocusWithin, setIsFocusWithin] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;

        const handleFocusIn = () => setIsFocusWithin(true);
        const handleFocusOut = (event: FocusEvent) => {
            // Check if the new focused element is still within the node
            if (node && !node.contains(event.relatedTarget as Node)) {
                setIsFocusWithin(false);
            }
        };

        node.addEventListener("focusin", handleFocusIn);
        node.addEventListener("focusout", handleFocusOut);

        return () => {
            node.removeEventListener("focusin", handleFocusIn);
            node.removeEventListener("focusout", handleFocusOut);
        };
    }, []);

    return { ref, isFocusWithin };
};

export { useFocusWithin };
